export const FETCH_SESIONES_REQUEST = "FETCH_SESIONES_REQUEST";
export const FETCH_SESIONES_SUCCESS = "FETCH_SESIONES_SUCCESS";
export const FETCH_SESIONES_FAILURE = "FETCH_SESIONES_FAILURE";
